import React, { useState } from 'react';
import styles from './demoScreen.module.css';
import romiImg from '../../images/romi-hero2.webp';
import maximovaLogo from '../../images/maximova-logo.webp';
import FormModal from '../../components/formModal/FormModal';

function DemoScreen() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <section className={styles.hero}>
        {/* Ambient glows */}
        <div className={styles.glowTopRight} />
        <div className={styles.glowBottomCenter} />
        <div className={styles.glowLeft} />

        {/* Floating sparkles */}
        <div className={`${styles.sparkle} ${styles.sparkle1}`} />
        <div className={`${styles.sparkle} ${styles.sparkle2}`} />
        <div className={`${styles.sparkle} ${styles.sparkle3}`} />
        <div className={`${styles.sparkle} ${styles.sparkle4}`} />
        <div className={`${styles.sparkle} ${styles.sparkle5}`} />

        {/* Decorative arcs */}
        <div className={styles.arcLeft} />
        <div className={styles.arcRight} />

        <div className={styles.container}>

          {/* ── Text Section ── */}
          <div className={styles.textSection}>
            <div className={styles.enterUp1}>
              <p className={styles.heroLine1}>
                הדרך להפוך את התשוקה שלך ליופי
              </p>
            </div>

            <div className={styles.enterUp2}>
              <h1 className={styles.heroHeadline}>
                <span className={styles.heroHeadlineText}>לקריירה רווחית</span>
                <span className={styles.headlineUnderline} />
              </h1>
            </div>

            <div className={styles.enterUp3}>
              <p className={styles.heroLine3}>
                עם החופש שתמיד חלמת עליו
              </p>
            </div>

            <div className={styles.enterUp4}>
              <p className={styles.heroObjection}>
                (גם אם לא נגעת בפינצטה בחיים וגם אם את בטוחה שיש לך ״שתי ידיים שמאליות״)
              </p>
            </div>
          </div>

          {/* ── Image + CTA Section ── */}
          <div className={styles.visualSection}>
            <div className={`${styles.imgArea} ${styles.enterImg}`}>
              <div className={styles.imgGlowOuter} />
              <div className={styles.imgGlowInner} />
              <img src={romiImg} alt="רומי פרץ" className={styles.heroImg} loading="lazy" />

              {/* Bold ribbon under image */}
              <div className={styles.ribbon}>
                <span className={styles.ribbonText}>מדריכה בינלאומית מטעם</span>
                <img src={maximovaLogo} alt="Maximova" className={styles.ribbonLogo} loading="lazy" />
              </div>
            </div>

            <div className={`${styles.ctaWrapper} ${styles.enterCta}`}>
              <button
                className={styles.ctaBtn}
                onClick={() => setIsFormOpen(true)}
              >
                <span className={styles.ctaShine} />
                <span className={styles.ctaContent}>
                  רומי, אני רוצה לשמוע פרטים
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M19 12H5M12 5l-7 7 7 7" />
                  </svg>
                </span>
              </button>

              {/* Social proof */}
              <p className={styles.socialProof}>
                <svg className={styles.starIcon} width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
                50+ בוגרות כבר עובדות בתחום
              </p>
            </div>
          </div>

        </div>
      </section>

      <FormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
}

export default DemoScreen;
